import { hasValue } from "@advosys/component-react-utils";
export const formatMatterTypeDisplayValue = (matterType) => hasValue(matterType) ? `${matterType.id} - ${matterType.description}` : undefined;
